import { useTagsHook } from "../../../Hooks/communicators/useTagsHook";

export default function TagSelector() {
    const {
        selectedTagPage,
        tagsLoading,
        setSelectedTagPage,
    } = useTagsHook();

    return (
        <div className='my-8 flex justify-center items-center flex-col'>
            <p className='text-2xl font-normal mb-4'>Manage Tags</p>
            <p className='text-lg font-light mb-4'>Select an action to perform on Tags</p>
            <div className='flex justify-between items-center my-4'>
                <div className='flex justify-end items-center'>
                    <button
                        onClick={() => setSelectedTagPage(1)}
                        className='bg-blue-400 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>List Tags</button>
                    <button
                        onClick={() => setSelectedTagPage(2)}
                        className='bg-green-500 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>Create New Tag</button>
                    <button
                        onClick={() => setSelectedTagPage(3)}
                        className='bg-yellow-500 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>Update Tags</button>
                    <button
                        onClick={() => setSelectedTagPage(4)}
                        className='bg-red-500 text-white p-2 rounded-md ml-4 transition ease-in-out delay-75 hover:scale-110 hover:transition-all hover:ease-in-out'>Delete Tags</button>
                </div>
            </div>
        </div>
    )
}
